import classNames from 'classnames';

import { ArticleCardBottomImage } from '~components/ArticleCardBottomImage/ArticleCardBottomImage';
import { ScrollContainer } from '~components/ScrollContainer/ScrollContainer';
import { Section } from '~components/Section/Section';
import { HeaderSection } from '~containers/MainPage/HeaderSection/HeaderSection';
import { useBreakpoints } from '~hooks/useBreakpoints';

import styles from './SectionRecent.module.scss';
import { SectionRecentProps } from './SectionRecent.types';

const ARTICLES_COUNT = 3;

export function SectionRecent({
  title,
  titleBacklight,
  articles,
  ...sectionProps
}: SectionRecentProps) {
  const [, { isDesktop }] = useBreakpoints();

  if (!articles.length) return null;
  const featuredArticles = articles.slice(0, ARTICLES_COUNT);

  return (
    <Section className={classNames(styles.section)} {...sectionProps}>
      {title && (
        <HeaderSection
          title={title}
          titleBacklight={titleBacklight}
          hasPageCategory={false}
        />
      )}
      <ScrollContainer active={!isDesktop}>
        <div className={classNames(styles.articles)}>
          {featuredArticles.map((article, key) => (
            <ArticleCardBottomImage
              {...article}
              key={key}
              className={styles.article}
            />
          ))}
        </div>
      </ScrollContainer>
    </Section>
  );
}
